module.exports = __webpack_public_path__ + "static/media/autokar3 (10).6566b49c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar3 (10).jpg
// module id = 856
// module chunks = 0